import { WidgetOptions } from '@csnext/cs-core';
import { CardOptions } from '../..';

/** Markdown widget options, from vue-markdown (https://github.com/miaolz123/vue-markdown) */
export class CardWidgetOptions extends WidgetOptions {
  public card?: CardOptions;
}

